import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ErrorMessage, SuccessMessage, WaringMessage } from '../../environment/ToastMessage';
import { PrivateAxios } from '../../environment/AxiosInstance';

function RePassword() {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const [showPassword1, setShowPassword1] = useState(false);
    const togglePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };

    const [error, setError] = useState({})

    const navigate = useNavigate();

    const [user, setUser] = useState({
        newpassword: "",
        password: ""
    })
    const location = useLocation();
    const data = location.state;

    const Updatepassword = (e) => {
        e.preventDefault();
        if (user.password != user.newpassword) {
            WaringMessage("Password does not matched !")
        } else {
            if (data) {
                PrivateAxios.post('user/update-password', { id: data, password: user.password })
                    .then((res) => {
                        navigate("/login");
                        SuccessMessage(res.data.msg);
                    }).catch((err) => {
                        ErrorMessage(err.response?.data.msg)
                    })
            } else {
                navigate("/login")
            }
        }

    }
    //dark theme image change
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        // Check for the theme on initial load
        const currentTheme = document.body.classList.contains("dark-theme");
        setIsDarkTheme(currentTheme);

        // Listen for changes to the body's class (if toggling happens outside this component)
        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains("dark-theme");
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme image change end

    return (
        <>
            <div className='login-auth-wrap'>
                <div className='container'>
                    <div className='row justify-content-evenly align-items-center'>
                        <div className='col-lg-5 col-md-6 col-sm-12'>
                            <div className='loginBox'>
                                <div className="logo-wrap">
                                    {/* <a href="/"><img src={process.env.PUBLIC_URL + 'assets/images/logo-navy.png'} alt="Growthh" className='img-fluid' /></a> */}
                                    <div>
                                        <img
                                            src={
                                                isDarkTheme
                                                    ? `${process.env.PUBLIC_URL}/assets/images/logo-white.png`
                                                    : `${process.env.PUBLIC_URL}/assets/images/logo-navy.png`
                                            }
                                            className="img-fluid"
                                            alt="Growthh"
                                        />
                                    </div>
                                </div>
                                <h1 className='login-title'>
                                    Don't worry! <br />
                                    <span className='position-relative sign-in me-2'>
                                        <span>RESET</span>
                                        <svg viewBox="0 0 156 59" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-blue login-svg"><path d="M156 41C156 50.9411 147.89 58.735 138.408 55.7499C135.073 54.7001 131.284 53.8018 124.799 53.8018C109.2 53.8018 109.197 59 93.598 59C77.9988 59 77.9987 53.8018 62.3995 53.8018C46.8003 53.8018 46.7977 59 31.1985 59C24.7151 59 20.9263 58.102 17.5923 57.0526C8.1099 54.0677 0 45.7429 0 35.8018V18C0 8.05888 8.1099 0.265901 17.5923 3.2508C20.9263 4.30029 24.7151 5.19824 31.1985 5.19824C46.7977 5.19824 46.7977 0 62.3995 0C78.0013 0 77.9988 5.19824 93.598 5.19824C109.197 5.19824 109.197 0 124.799 0C131.284 0 135.073 0.898168 138.408 1.94782C147.89 4.93288 156 13.2571 156 23.1982V41Z" ></path></svg>
                                    </span>
                                    your password.
                                </h1>
                                <div className='form-wrap'>
                                    <form className='w-100' onSubmit={Updatepassword} >
                                        <div className="mb-4">
                                            <div className="input-group">
                                                <div className="input-group-text"><i className="fas fa-lock" /></div>
                                                <input required className={error.password ? "form-control border-right-0 is-invalid" : "form-control border-right-0"} onChange={(e) => setUser({ ...user, newpassword: e.target.value })} value={user.newpassword} type={showPassword ? "text" : "password"} name="password" placeholder="Enter Password" autoComplete="current-password" id="password" style={{ paddingRight: 20, }} />
                                                <div className="input-group-text bg-white">
                                                    <i className={`fas ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibility} style={{ marginRight: 5, cursor: 'pointer', color: '#777' }} />
                                                </div>
                                            </div>
                                            {/* {error.password ? <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.password}</span> : ""} */}

                                        </div>

                                        <div className="mb-4">
                                            <div className="input-group">
                                                <div className="input-group-text"><i className="fas fa-lock" /></div>
                                                <input className={error.password ? "form-control border-right-0 is-invalid" : "form-control border-right-0"} onChange={(e) => setUser({ ...user, password: e.target.value })} value={user.password} type={showPassword1 ? "text" : "password"} name="password" placeholder="Enter Password" autoComplete="current-password" required id="password" style={{ paddingRight: 20, }} />
                                                <div className="input-group-text bg-white">
                                                    <i className={`fas ${showPassword1 ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibility1} style={{ marginRight: 5, cursor: 'pointer', color: '#777' }} />
                                                </div>
                                            </div>
                                            {/* {error.password ? <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.password}</span> : ""} */}

                                        </div>

                                        <button type="submit" name="submit" className="btn btn-exp-primary-dark w-100 f-s-18">Update Password</button>
                                    </form>
                                    <h6 className='mt-4 mb-0 text-center text-muted f-w-medium'>
                                        Don’t want to reset ? <Link to="/login" className='text-exp-blue1'>Sign In</Link>
                                    </h6>
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-5 col-md-6 col-sm-12 login-right-col'>
                            <div className='login-right-wrap'>
                                <div className='text-end imgBx'>
                                    <img src={process.env.PUBLIC_URL + 'assets/images/login-right.webp'} alt="login" />
                                </div>
                                <div className='textBx'>
                                    "Before Growthh, my to-do lists were scattered all around! Now, everything is in order and in one place."
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RePassword